import React from 'react';
import { Button, Modal, Text } from '@nimbus-ds/components';
import { useTranslationWithPrefix } from 'commons/utils';

interface PendingPaymentsForChargebackModalProps {
  open: boolean;
  onDismiss: () => void;
}

const PendingPaymentsForChargebackModal = ({
  open,
  onDismiss,
}: PendingPaymentsForChargebackModalProps) => {
  const { t } = useTranslationWithPrefix(
    'home.pendingPaymentsForChargebackModal',
  );

  const handleMoreInformation = () => {
    window.open(t('moreInformationLink'), '_blank', 'noopener,noreferrer');
  };

  return (
    <Modal open={open} onDismiss={onDismiss}>
      <Modal.Header title={t('title')} />
      <Modal.Body>
        <Text as="p" fontSize="base" lineHeight="base" textAlign="left">
          {t('description')}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleMoreInformation} appearance="primary">
          {t('moreInformation')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PendingPaymentsForChargebackModal;
